module.exports = __webpack_public_path__ + "img/gy.75fe290a.png";